{
  "version": 1,
  "asset_id": "a6b57008-b031-44fb-8305-f64d62b3b7ea",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a6b57008-b031-44fb-8305-f64d62b3b7ea/hiatal-type-3-v3-1254.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a6b57008-b031-44fb-8305-f64d62b3b7ea/hiatal-type-3-v3-1254.jpg",
  "original_filename": "hiatal-type-3-v3-1254.jpg",
  "size": 275481,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T22:48:14Z"
}
